import * as firebase from "firebase/app";

const config = {
  apiKey: "AIzaSyCR7b7w1K5ZjRGxVAOBeDIUgzN8BtVlSQU",
  authDomain: "travelapp-dd0fd.firebaseapp.com",
  databaseURL: "https://travelapp-dd0fd.firebaseio.com",
  projectId: "travelapp-dd0fd",
  storageBucket: "tyqup92jjpdlwuqsjvly.appspot.com",
  messagingSenderId: "1001519443421",
  appId: "1:1001519443421:web:39b798349bd308aaea9a34"
};
let app: any;

function initFirebase() {
  if (firebase.apps.length > 0) {
    app = firebase.app();
    return;
  }
  app = firebase.initializeApp(config);
}

export { initFirebase, app };
